import { AppConfigService } from '@/services/app-config.service';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[appTooltip]',
    providers: [MatTooltip],
    standalone: true
})
export class TooltipDirective {
  @Input() appTooltip: string;

  constructor(private elementRef: ElementRef, private tooltip: MatTooltip, public appConfigService: AppConfigService,) {}

  @HostListener('mouseover') mouseover() {
    if (!this.appConfigService.isMobileApp) {
      this.tooltip.message = this.appTooltip;
      this.tooltip.show();
    }
  }
  @HostListener('mouseleave') mouseleave() {
    this.tooltip.hide();
  }
}
